import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getAllCaixaEntrada, CaixaEntradaModel, processos } from '@app/api/caixaEntrada';
import { Usuario, getUsuarioInfo } from '@app/api/usuario';
import { getLoggedId } from '@app/helpers';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import {
  GridView,
  SimpleView,
  Widget,
  Table,
  ColumnProps,
  usePromise,
  Button,
  FormInput,
  Col,
  Row,
  FormResetButton,
  Form,
  FormDatePicker,
  ColumnType,
  CompositeView,
} from '@digital/ui';
import { Tooltip, Icon } from 'antd';
import moment from 'moment';
import { useRecoilValue } from 'recoil';

import { usuarioLogadoState } from '@app/atoms';

import { compareText, compareDates } from '../../helpers/comparators';

const CaixaEntrada = () => {
  const usuarioLogado = useRecoilValue(usuarioLogadoState);
  const [gpc, setGpc] = useState<boolean>(false);
  const [usuario, setUsuario] = useState<Usuario>();
  const [filterResponsavel, setFilterResponsavel] = useState<any[]>();
  const [data, setData] = useState<any[]>();

  const RenomearColunas = () => {
    const allElementer = document.querySelectorAll('.ant-table-column-sorter-inner-full');
    allElementer.forEach(element => {
      element.title = 'Ordenar';
    });
  };
  RenomearColunas();

  const handleRedirect = (link: string) => {
    // document.location.href = link;
    window.open(link);
  };
  // `getLoggedId()` e um snapshot do JWT no render. Sem o fallback do recoil (que chega
  // depois e destrava o re-render), montar antes da identidade deixa a tela vazia ate F5.
  const userId = getLoggedId() || usuarioLogado.id;

  //const [caixaEntradaPromise] = usePromise(
  //  () => {
  //    if (!userId) return Promise.resolve(undefined);
//
  //    const source = axios.CancelToken.source();
//
  //    const promise = getAllCaixaEntrada(userId, { cancelToken: source.token });
//
  //    (promise as any).cancel = () => source.cancel('Request cancelled');
//
  //    return promise;
  //  },
  //  [userId],
  //  [] as CaixaEntradaModel[],
  //);

  useEffect(() => {
    if (userId) {
      getUsuarioInfo(userId).then(data => {
        if (data) {
          setUsuario(data);
          if (
            data.perfis.includes('f1cc67b3-abcb-487f-8b38-b35760e264e5') ||
            data.perfis.includes('1642cf10-9b32-489f-98eb-5be22b2bbaa4') ||
            data.perfis.includes('7ed9e512-c30e-45f6-b7c8-17d77958a142')
          ) {
            setGpc(true);
            setFilterResponsavel([data.nome]);
          }
        }
      });
    }
  }, [userId]);

  useEffect(() => {
    if (userId) {
  
      const source = axios.CancelToken.source();
  
      getAllCaixaEntrada(userId, { cancelToken: source.token }).then((data: CaixaEntradaModel[] | undefined) => {
        if (data)
          //if (
          //  usuario.perfis && (
          //    usuario.perfis.includes('f1cc67b3-abcb-487f-8b38-b35760e264e5') ||
          //    usuario.perfis.includes('1642cf10-9b32-489f-98eb-5be22b2bbaa4') ||
          //    usuario.perfis.includes('7ed9e512-c30e-45f6-b7c8-17d77958a142')
          //  )
          //) {
            setData([...data]);
            //setData(data);
            //setData(data.filter(item => item.responsavel === usuario.nome));
          //}
      });
  
      return () => {
        source.cancel("Request canceled on unmount");
      };
    }
  }, [usuario, userId]);

  const columns: ColumnProps<any>[] = [
    {
      title: 'Processo',
      dataIndex: 'processo',
      sorter: (a, b) => compareText(a.processo, b.processo),
      width: '10%',
      filters: processos || [],
      filterMultiple: true,
      filterIcon: filtered => <Icon type="filter" style={{ minWidth: 'auto', border: 'none' }} />,
      onFilter: (value, record) => record.processo.indexOf(value) === 0,
    },
    {
      title: 'Atividade',
      dataIndex: 'nome',
      sorter: (a, b) => compareText(a.nome, b.nome),
      width: '25%',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Atividade"
              name="nome"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) => record.nome && record.nome.toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Inf.',
      dataIndex: 'infoComplementarList',
      sorter: (a, b) => compareText(a.infoComplementar, b.infoComplementar),
      width: '15%',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar em Inf. Complementar"
              name="nome"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.infoComplementar && record.infoComplementar.toString().toLowerCase().includes(value.toLowerCase()),
      render: (list: string[]) => (
        <>
          {list.map((value, key) => {
            const text = value || '';
            const isTruncated = text.length > 24;
            const truncated = isTruncated ? text.slice(0, 24) + '...' : text;

            return isTruncated ? (
              <div>
              <Tooltip key={key} title={text}>{truncated}</Tooltip>
              </div>
            ) : (
              <div key={key}>{text}</div>
            );
          })}
        </>
      ),
    },
    {
      title: 'Contrato/pcs',
      dataIndex: 'contrato',
      sorter: (a, b) => compareText(a.contrato, b.contrato),
      width: '5%',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Contrato"
              name="contrato"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.contrato && record.contrato.toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Fornecedor',
      dataIndex: 'fornecedor',
      sorter: (a, b) => compareText(a.fornecedor, b.fornecedor),
      width: '5%',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Fornecedor"
              name="fornecedor"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.fornecedor && record.fornecedor.toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Responsável',
      dataIndex: 'responsavel',
      sorter: (a, b) => compareText(a.responsavel, b.responsavel),
      width: '25%',
      filteredValue: filterResponsavel,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, filters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Responsável"
              name="responsavel"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
              onPressEnter={() => {
                setFilterResponsavel(selectedKeys);
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  setFilterResponsavel(selectedKeys);
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.responsavel && record.responsavel.toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: 'Início',
      dataIndex: 'dataIniciaoString',
      sorter: (a, b) => compareDates(a.dataIniciaoString, b.dataIniciaoString),
      width: '5%',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormDatePicker
              placeholder="00/00/0000"
              valueFormat={dateFormat}
              format={dateFormat}
              name="dataIniciaoString"
              style={{ marginTop: '15px' }}
              onFocus={(e: any) => {
                const { value } = e.target;
                if (value !== undefined && value.length > 0 && setSelectedKeys) setSelectedKeys([value]);
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataIniciaoString && moment(record.dataIniciaoString).format(dateFormat) === value,
    },
    {
      title: 'Prazo',
      dataIndex: 'dataConclusaoEstimada',
      render: data => {
        const dias = moment(data).startOf('day').diff(moment().startOf('day'), 'days');
        const tipoPrazo = dias <= -1 ? 'Vencido' : dias === 0 ? 'Vence Hoje' : 'Em dia';

        return (
          <Tooltip title={tipoPrazo}>
            <span>{moment(data).format(dateFormat)}</span>
          </Tooltip>
        );
      },
      type: ColumnType.Date,
      sorter: (a, b) => compareDates(a.dataConclusaoEstimada, b.dataConclusaoEstimada),
      width: '5%',
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormDatePicker
              placeholder="00/00/0000"
              valueFormat={dateFormat}
              format={dateFormat}
              name="dataConclusaoEstimada"
              style={{ marginTop: '15px' }}
              onFocus={(e: any) => {
                const { value } = e.target;

                if (value !== undefined && value.length > 0 && setSelectedKeys) setSelectedKeys([value]);
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataConclusaoEstimada && moment(record.dataConclusaoEstimada).format(dateFormat) === value,
    },
    {
      title: 'Ações',
      dataIndex: 'acao',
      render: (index, item) => {
        return (
          <Tooltip title="Executar Atividade">
            <Button
              type="link"
              icon="arrows-circled_right_2"
              size="small"
              onClick={() => {
                handleRedirect(item.link);
              }}
            />
          </Tooltip>
        );
      },
      width: '5%',
    },
  ];

  return (
    <CompositeView>
      <GridView>
        <Widget title="Lista de atividades pendentes">
          <Table
            rowKey="rowId"
            columns={columns}
            dataSource={data}
            rowClassName={record => {
              const dias = moment(record.dataConclusaoEstimada)
                .startOf('day')
                .diff(moment().startOf('day'), 'days');

              if (dias <= -1) return 'prazo-entrega-vencido';
              if (dias === 0) return 'prazo-entrega-hoje';
              return 'prazo-entrega-ok';
            }}
          />
        </Widget>
      </GridView>
    </CompositeView>
  );
};

export default CaixaEntrada;
